import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

// Define a service using a base URL and expected endpoints
export const orderSortApi = createApi({
  reducerPath: 'orderSortApi',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://onza-api.ibm.kg/api/order/',
    prepareHeaders: (headers, { getState }) => {
      let { auth: { auth } } = getState()
      if (typeof auth == "string") {
        auth = JSON.parse(auth);
      }
      headers.set("Authorization", `Bearer ${auth?.accessToken}`);
      return headers;
    },
  }),
  tagTypes: ["sort-order"],
  endpoints: (builder) => ({
    getOrderSort: builder.query({
      query: () => {
        return {
          url: `order-sort`,

        }
      },
      providesTags: ["sort-order"],
    }),
    orderSort: builder.mutation({
      query: (body) => {
        return {
          url: "order-sort",
          body: body,
          method: "Post"
        }
      },
      invalidatesTags: ["sort-order"],
    }),
    orderPayment: builder.mutation({
      query: (body) => {
        return {
          url: "order-payment",
          body: body,
          method: "Post"
        }
      },
      invalidatesTags: ["sort-order"],
    }),
    getOrderPvz: builder.query({
      query: () => {
        return {
          url: `order-pvz`,

        }
      },
      providesTags: ["sort-order"],
    }),
    getOrderDelivery: builder.query({
      query: () => {
        return {
          url: `order-delivery`,

        }
      },
      providesTags: ["sort-order"],
    }),
    orderPvz: builder.mutation({
      query: (body) => {
        return {
          url: "order-pvz",
          body: body,
          method: "Post"
        }
      },
      invalidatesTags: ["sort-order"],
    }),
    orderDelivery: builder.mutation({
      query: (body) => {
        return {
          url: "order-delivery",
          body: body,
          method: "Post"
        }
      },
      invalidatesTags: ["sort-order"],
    }),
  }),
})

export const {
  useGetOrderSortQuery,
  useOrderSortMutation,
  useOrderPaymentMutation,
  useGetOrderPvzQuery,
  useOrderPvzMutation,
  useGetOrderDeliveryQuery,
  useOrderDeliveryMutation } = orderSortApi